module.exports = __webpack_public_path__ + "img/店铺管理.cb2e7d91.png";